import {UeThemeOptions} from '../ueTheme.types';

export const twinColors = {
    pink: {
        brightOrchid: '#F43C9C',
        darkOrchid: '#D01073'
    },

    light: {
        platinum: '#EEEEF0',
        aluminium: '#F7F7F7',
        iron: '#6C6C6E'
    },

    dark: {
        carbon: '#1B191E',
        chrome: '#313036',
        titanium: '#8D8B8D'
    }
};

export const twinAccentColors = {
    dark: {
        orchid: twinColors.pink.darkOrchid,
        sky: twinColors.pink.darkOrchid,
        forest: twinColors.pink.darkOrchid,
        galaxy: twinColors.pink.darkOrchid,
        fire: twinColors.pink.darkOrchid
    },
    bright: {
        orchid: twinColors.pink.brightOrchid,
        sky: twinColors.pink.brightOrchid,
        forest: twinColors.pink.brightOrchid,
        galaxy: twinColors.pink.brightOrchid,
        fire: twinColors.pink.brightOrchid
    }
};

export const gradientColors = {
    sky: {
        from: twinColors.pink.brightOrchid,
        to: twinColors.pink.darkOrchid
    },
    forest: {
        from: twinColors.pink.brightOrchid,
        to: twinColors.pink.darkOrchid
    },
    fire: {
        from: twinColors.pink.brightOrchid,
        to: twinColors.pink.darkOrchid
    },
    galaxy: {
        from: twinColors.pink.brightOrchid,
        to: twinColors.pink.darkOrchid
    },
    orchid: {
        from: twinColors.pink.brightOrchid,
        to: twinColors.pink.darkOrchid
    },
    black: {
        from: '#000',
        to: '#000'
    },
    white: {
        from: '#fff',
        to: '#fff'
    }
};

export const setTwinmotionOverrides = (twinThemeConfig: UeThemeOptions): UeThemeOptions => {
    if (twinThemeConfig.overrides) {
        if (!twinThemeConfig.overrides.MuiButton) {
            twinThemeConfig.overrides.MuiButton = {};
        }

        twinThemeConfig.overrides.MuiButton.root = {
            ...twinThemeConfig.overrides.MuiButton.root,
            borderRadius: 100,
            borderImage: 'unset'
        };
    }

    return twinThemeConfig;
};
